(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
